<template>
	<div class="phoneService">
		<!-- 图片 -->
		<div class="phoneService_head">
			<el-image style="width: 100%;" :src="src"></el-image>
		</div>
		<!-- 方格列表 -->
		<div class="phoneService_view" @click="changeSelect(item, index)" v-for="(item,index) in nvaList" :key="index">
			<p>{{item.label}}</p>
			<i class="el-icon-arrow-right"></i>
		</div>
	</div>
</template>

<script>
	import {
		getVipUser,
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {
				userInfo: {},
				nvaList: [{
					label: '缴费管理',
					name: 'phonePaymanage',
				}, {
					label: '信息变更',
					name: 'phoneInfoChange',
				}, {
					label: '会员证书',
					name: 'phoneCertificate',
				}],
				src: require('../../assets/img/phoneIndex/phonebgc.png')
			}
		},
		created() {
			this.getVipUser()
		},
		methods: {
			// 获取用户信息
			async getVipUser() {
				await getVipUser({
					success: res => {
						// console.log('用户信息', res)
						this.userInfo = res.data
					}
				})
			},
			changeSelect(item, index) {
				if (this.userInfo.flow_status === 1 || this.userInfo.flow_status === 2) {
					//1\ 基本信息有审核中、审核通过
					//2\ 证书信息有审核中、审核通过
					if (index == 2) {
						// 会员证书
						this.$message.warning('您好，您的材料正在审核，审核结束后可查看电子证书，请耐心等待！')
					} else if (index == 0) {
						// 缴费管理
						this.$message.warning('您好，请提交基本信息，如已提交等待材料审核结果后重试！')
					} else {
						this.$router.push({
							name: item.name
						})
					}
				} else {
					// 3\" 控制显示缴费
					// ==''
					if (this.userInfo.status != 2) {
						// 3是基本信息和证书信息都有审核中、审核通过
						if (index == 2) {
							// 会员证书
							this.$message.warning('您好，您的材料正在审核，审核结束后可查看电子证书，请耐心等待！')
						} else {
							this.$router.push({
								name: item.name
							})
						}
					} else {
						this.$router.push({
							name: item.name
						})
					}
				}
			},
		}
	}
</script>

<style scoped>
	.phoneService {
		height: 90vh;
		background-image: linear-gradient(to bottom, #ed653b 20%, #f5f5f5 100%);
		background-repeat: no-repeat;
	}
	.phoneService_view:last-child{
		margin-bottom: 80px;
	}
	.phoneService_view {
		margin-top: 30px;
		width: 90%;
		margin-left: 5%;
		text-align: center;
		line-height: 80px;
		height: 80px;
		background-color: #fff;
		border-radius: 15px;
		color: #fff;
		display: flex;
		font-size: 18px;
		align-items: center;
		justify-content: space-around;
		background-image: linear-gradient(to right, #c22c25 20%, #f1b9a7 100%);
		box-shadow: 0px 0px 15px 4px rgb(0 0 0 / 6%);
	}
</style>
